import {Component, computed, input, viewChild, ChangeDetectionStrategy} from "@angular/core"
import {MaterialNode, MaterialSocketUiDefinition} from "@cm/material-nodes"
import {MaterialNodeIoComponent} from "@material-editor/components/sockets/material-node-io/material-node-io.component"
import {Socket, SocketPosition} from "@socket-editor/types"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-output-socket",
    imports: [MaterialNodeIoComponent],
    templateUrl: "./material-output-socket.component.html",
    styleUrl: "./material-output-socket.component.scss",
})
export class MaterialOutputSocketComponent {
    public readonly $definition = input.required<MaterialSocketUiDefinition>({alias: "definition"})
    public readonly $nodeId = input.required<string>({alias: "nodeId"})
    public readonly $socket = computed<Socket>(() => {
        const definition = this.$definition()
        return {
            id: definition.name,
            inputField: !!definition.input,
            label: definition.label,
            type: "output",
            valueType: definition.valueType,
            paramType: "socket",
            value: this.$material().parameters.settings[definition.name],
        }
    })
    readonly $material = input.required<MaterialNode>({alias: "material"})
    readonly $nodeIo = viewChild.required(MaterialNodeIoComponent)

    getSocketPosition(): SocketPosition {
        return this.$nodeIo().getSocketPosition()
    }
}
